// extracted by mini-css-extract-plugin
module.exports = {"visuallyHidden":"ContinueLink_visuallyHidden__4bFpV","stars":"ContinueLink_stars__fufnZ","link":"ContinueLink_link__An8_X","spinner":"ContinueLink_spinner___dHaZ"};